import { Alert } from "@mui/material";
import { Button, Typography } from "@foodpilot/foods";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { useActionPlanTemplate } from "src/api/client-api/actionPlanTemplates/useActionPlanTemplate";
import { TemplateEditor } from "./TemplateEditor";

export const ActionPlanTemplateEdit = () => {
    const { templateId } = useParams();
    const query = useActionPlanTemplate(templateId);
    const { t } = useTranslation();

    if (query.isError) {
        return (
            <Alert severity="error">
                {t(
                    "settings.action_plan_templates.detail.load_failed",
                    "Unable to load this template. It may have been deleted, or you may not have access to it.",
                )}
                <Button variant="text" onClick={() => query.refetch()}>
                    {t("settings.action_plan_templates.retry", "Try again")}
                </Button>
            </Alert>
        );
    }

    if (!query.data) {
        return (
            <Typography role="status">{t("settings.action_plan_templates.loading", "Loading templates…")}</Typography>
        );
    }

    if (!query.data.canModify || query.data.status === "archived") {
        return (
            <Alert severity="info">
                {t("settings.action_plan_templates.editor.unavailable", "This template cannot be edited.")}
            </Alert>
        );
    }

    return <TemplateEditor key={`${query.data.id}-template-editor`} template={query.data} />;
};
